export default function LoadingOverlay() {
	return <div className="loading-overlay">
		<div className="loading-spinner" />
	</div>;
}